import { useCallback, useEffect } from "react";

const useIntervalUpdatePrice = (fetchPrice: () => void) => {
    const intervalFetchPrice = useCallback(() => {
        return setInterval(fetchPrice, 8000);
    }, [fetchPrice]);

    useEffect(() => {
        let interval = intervalFetchPrice();

        const handleVisibilityChange = () => {
            if (document.hidden) {
                clearInterval(interval);
            } else {
                interval = intervalFetchPrice();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );
        };
    }, [intervalFetchPrice]);
};

export default useIntervalUpdatePrice;
